import { render } from "./PriceComponent.vue?vue&type=template&id=0b579d08"
import script from "./PriceComponent.vue?vue&type=script&lang=js"
export * from "./PriceComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__